<template>
    <div>
        <v-sheet height="64">
            <v-toolbar flat color="white">
            <v-btn outlined class="mr-4" @click="setToday">
                Today
            </v-btn>
            <v-btn fab text small @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab text small @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>
        </v-sheet>

        <v-sheet>
            <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :event-margin-bottom="3"
            :now="today"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @change="updateRange"
            ></v-calendar>
        </v-sheet>

        <v-card
            tile
            color="primary"
        >
            <v-card-title class="white--text text-uppercase">
                Cleaning Jobs
            </v-card-title>

            <v-card-text>
                <v-expansion-panels v-model="panel" multiple dark accordion>
                    <v-expansion-panel
                        v-for="(jobs, i) in cleaning_jobs"
                        :key="i"
                    >
                        <v-expansion-panel-header color="#1565c0">
                        {{ jobs.formatted_date }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content color="#1565c0">
                            <v-list two-line tile flat class="py-0 hover-list">
                                <v-expansion-panels dark accordion>
                                    <v-expansion-panel
                                    v-for="(job, index) in jobs.items"
                                    :key="jobs.date + '-' + index"
                                    >
                                    <v-expansion-panel-header color="#003a6f">
                                        {{ userName(index) }}     
                                            <v-chip
                                            class="ml-2"
                                            small
                                            color="primary"
                                            dark
                                            style="flex: none;"
                                            >
                                            {{ job.length }}
                                            </v-chip>
                                            <v-spacer></v-spacer>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-list two-line tile flat class="py-0 hover-list">
                                                <template v-for="(cljob, indexx) in job">
                                                <v-list-item
                                                :key="`job-${indexx}`"
                                                :value="cljob.id"                 
                                                >
                                                    <template>
                                                        <v-list-item-content @click.stop="openJob(cljob.id)">
                                                            <v-list-item-title>{{ cljob.customer.street_address+ ', ' + cljob.customer.city + ', ' + cljob.customer.state + ' ' + cljob.customer.zip }}</v-list-item-title>
                                                            <v-list-item-subtitle v-html="cljob.customer.title"></v-list-item-subtitle>
                                                            <v-list-item-subtitle>{{ cljob.job_time | moment('MMMM Do YYYY, h:mm a') }}</v-list-item-subtitle>
                                                            <div>
                                                                <v-chip
                                                                class="mr-2 mb-1"
                                                                :color="getColor(cljob.status)"
                                                                text-color="white"
                                                                small
                                                                label
                                                                >
                                                                {{ cljob.status | capitalize }}
                                                                </v-chip>
                                                            </div>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-list-item-icon class="ma-0 mb-1">
                                                                <v-btn small tile class="mr-1" elevation="0" color="#0298c6" dark @click.stop="googleLink(cljob.customer)">
                                                                    <v-icon dark>mdi-map-marker</v-icon>
                                                                </v-btn>

                                                                <v-btn small tile class="mr-1" color="#003a6f" elevation="0" dark @click.stop="dial(cljob.customer.phone)">
                                                                    <v-icon dark>mdi-phone</v-icon>
                                                                </v-btn>
                                                            </v-list-item-icon>
                                                        </v-list-item-action>
                                                    </template>
                                                </v-list-item>
                                                <v-divider
                                                :key="`dv-${indexx}`"
                                                ></v-divider>
                                            </template>
                                        </v-list>
                                    </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-list>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>

        </v-card>        
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    tab: null,
    loading: false,
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: '#1976D2', // default event color
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    cleaning_jobs: [],
    dialog: false,
    dialogDate: false,
    apiUrl: '',
    user_id: '',
    job_time: '',
    panel: []
  }),
  created() {
    this.apiUrl = this.$route.meta.api
  },
  mounted () {
    this.getEvents()
  },
  computed: {
    ...mapGetters({
        users: 'data/users',
    }),
    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)
      switch (this.type) {
        case 'month':
        return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
        return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
        return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },
    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    },
    cheight() {
      return window.innerHeight - 128
    }
  },
  watch: {
    start: function () {
      this.getEvents()
    },
  },
  methods: {
    async getEvents () {
      this.loading = true
      axios.get('crm/cleaning_calendar', {
          params: {
            month: this.start.month,
            year: this.start.year,
            user: this.user_id,
            job_time: this.job_time
          }
      })
      .then(response => {
          this.loading = false
          this.cleaning_jobs = response.data
          this.$nextTick()
      })
    },
    setDialogDate( { date }) {
      this.dialogDate = true
      this.focus = date
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    async showEvent ({ nativeEvent, event }) {
      if(event.id == 'cleaner') {
        this.user_id = event.user_id
        this.job_time = event.start
        await this.getEvents()
        this.goto('expand')
        this.panel = [0]
      } else {
        this.$router.push('/job/main/' + event.id)
        nativeEvent.stopPropagation()
      }
    },
    setToday () {
      this.focus = this.today
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    updateRange ({ start, end }) {
      this.start = start
      this.end = end
    },
    nth (d) {
      return d > 3 && d < 21
      ? 'th'
      : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    openJob(id) {
        window.open('https://cleaners.mrpoolal.com/#/job/'+id, '_blank');
    },
    getColor(status) {
      switch(status) {
          case 'completed':
              return 'green'
          case 'active':
              return 'light-blue'
          case 'cancelled':
              return 'red'
          default:
              // code block
      }
    },
    userName(id) {
        let cleaner = this.users.filter( user => {
            return parseInt(user.id) == parseInt(id)
        })

        if(cleaner.length > 0)
            return cleaner[0].name
        else
            return 'no name'
    },
  }
}
</script>